import TreeSoftService from '@/api/TreeSoftService'
import { HAS_FEE_APP_MODULES } from '../../helpers/enum'

const initialAppState = {
  ...HAS_FEE_APP_MODULES.reduce((acc, cur) => {
    const key = `APPID${cur.app_id}_MODULEID${cur.module_id}`
    return {
      ...acc,
      [key]: 0,
    }
  }, {}),
}

export default {
  namespaced: true,

  state: {
    pricing: {
      user: 0,
      branch: 0,
      warehouse: 0,
      messageLine: 0,
      email: 0,
      ...initialAppState,
    },
  },

  mutations: {
    setPricing (state, { type, value }) {
      state.pricing[type] = value
    },
  },

  actions: {
    async getPricing ({ commit }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getPricing') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getPricing')

        const response = await TreeSoftService.getPricing()

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getPricing')

        result = response.data

        if (result.success) {
          commit('setPricing', { type: 'user', value: result.data.user })
          commit('setPricing', { type: 'branch', value: result.data.branch })
          commit('setPricing', { type: 'warehouse', value: result.data.warehouse })
          commit('setPricing', { type: 'messageLine', value: result.data.messageLine })
          commit('setPricing', { type: 'email', value: result.data.email })

          Object.keys(result.data).forEach((key) => {
            const re = /APPID(\d+)_MODULEID(\d+)/g
            const match = re.exec(key)
            if (match != null) {
              const appId = Number(match[1])
              const moduleId = Number(match[2])
              commit('setPricing', { type: key, value: result.data[key] })
            }
          })
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/TreeSoft.js